/** Human-facing activity labels for bark-mcp's complete direct tool surface. */
export const LOOKUP_TOOL_DESCRIPTIONS: Record<string, string> = {
  start_here: 'Checking citation guidance',
  search: 'Searching regulatory sources',
  get: 'Reading source text',
  get_documents: 'Finding regulatory documents',
  get_structure: 'Reading document structure',
  get_context: 'Reading related provisions',
  get_concept_map: 'Mapping regulatory concepts',
  graph_walk: 'Following regulatory connections',
  trace_dependencies: 'Tracing dependencies',
  get_version_history: 'Checking version history',
  list_recent_amendments: 'Checking recent amendments',
  get_page: 'Reading document pages',
  swedish_law: 'Looking up Swedish law',
  online_search: 'Searching the web',
  web_search: 'Searching the web',
  search_chat_files: 'Searching your files',
  read_chat_file: 'Reading your file',
};
